import { render, staticRenderFns } from "./MS365Activities.vue?vue&type=template&id=0874daac&"
import script from "./MS365Activities.vue?vue&type=script&lang=ts&"
export * from "./MS365Activities.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports